import { render } from "./Coproprietes.vue?vue&type=template&id=9b93cae4&scoped=true"
import script from "./Coproprietes.vue?vue&type=script&lang=js"
export * from "./Coproprietes.vue?vue&type=script&lang=js"

import "./Coproprietes.vue?vue&type=style&index=0&id=9b93cae4&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b93cae4"]])

export default __exports__